import { z } from 'zod';

/**
 * A file a campaign form's own `file` field captured. The field's value is the
 * `id` and nothing else; the rest is what a screen shows beside it while the
 * form is being filled in. `fileSize` is a string because the column is a
 * `bigint` — .claude/rules/money.md's reason applied to a byte count.
 *
 * `scanStatus` is deliberately part of the payload: a file is uploaded and the
 * form is submitted without waiting for the verdict, so the screen says the
 * scan is still running rather than pretending the file is readable.
 */
export const formFileSchema = z.object({
  id: z.uuid(),
  fileName: z.string(),
  contentType: z.string(),
  fileSize: z.string(),
  scanStatus: z.enum(['pending', 'clean', 'infected', 'failed']),
});

export type FormFile = z.infer<typeof formFileSchema>;

export const formFileUploadInputSchema = z.object({
  fieldKey: z.string().min(1).max(40),
  fileSize: z.number().int().min(1),
});
